import { EnglishTestNotReqdReason, EnglishTestType, GradeLevel, GradeSystem } from 'types';
import { deepFreeze } from '../utils/deepFreeze.js';

export const ENGLISH_TEST_TYPE_VAL_LABEL_MAP: { [key: string]: string } = deepFreeze({
  IELTS_FOR_UKVI: 'IELTS for UKVI',
  IELTS_ACADEMIC: 'IELTS Academic',
  IELTS: 'IELTS General',
  ESOL_SELT: 'LanguageCert International ESOL SELT',
  ISE: 'Trinity College London Integrated Skills in English (ISE)',
  PTE_UKVI: 'PTE Academic UKVI',
  PTE: 'PTE Academic',
  PSI: 'PSI Services Skills for English UKVI',
  Cambridge: 'Cambridge Assessment English test',
  TOEFL: 'TOEFL',
  ELLT: 'OI Digital Institute English Language Level Test (ELLT)',
  UNI: `University's English test`,
});

export const NOT_REQUIRED_REASONS = deepFreeze(
  Object.entries(EnglishTestNotReqdReason).map(([value, label]) => ({
    label,
    value,
  })),
);

export const ENGLISH_TEST_TYPES = deepFreeze(
  Object.entries(EnglishTestType).map(([value, label]) => ({
    label,
    value,
  })),
);

export const QUALIFICATIONS = deepFreeze(
  Object.entries(GradeLevel).map(([value, label]) => ({
    label,
    value,
  })),
);

export const QUALIFICATION_GRADE_SYSTEMS = deepFreeze(
  Object.entries(GradeSystem).map(([value, label]) => ({
    label,
    value,
  })),
);

export const QUALIFICATION_VAL_LABEL_MAP: { [key: string]: string } = deepFreeze(
  Object.entries(GradeLevel).reduce(
    (map, [key, value]) => {
      map[key] = value;
      return map;
    },
    {} as { [key: string]: string },
  ),
);

export const ENGLISH_SPEAKING_COUNTRIES = deepFreeze([
  'Antiguans',
  'Australian',
  'Bahamian',
  'Barbadian',
  'Belizean',
  'Anguillan',
  'Bermudan',
  'British (IOT)',
  'Virgin Islander (British)',
  'Caymanian',
  'Falkland Islander',
  'Gibraltarian',
  'Montserratian',
  'Pitcairn Islander',
  'Saint Helenian',
  'South Georgia and the South Sandwich Islands',
  'Turks and Caicos Islander',
  'Canadian',
  'Dominican',
  'Grenadian',
  'Guyanese',
  'Jamaican',
  'Maltese',
  'New Zealander',
  'Kittian',
  'Saint Lucian',
  'Saint Vincentian',
  'Trinidadian',
  'American',
]);
